import { resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = (n) => (_pushScopeId("data-v-5cd969bc"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "main-content" };
const _hoisted_2 = { class: "productos-page" };
const _hoisted_3 = { class: "productos-content" };
const _hoisted_4 = {
    key: 0,
    class: "loading-overlay-global"
};
const _hoisted_5 = { class: "spinner-container" };
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "spinner-main" }, null, -1 /* HOISTED */));
const _hoisted_7 = { class: "form-group" };
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { class: "form-label-heading" }, "Imágenes del Producto (Máx. 5)", -1 /* HOISTED */));
const _hoisted_9 = { class: "image-upload-gallery" };
const _hoisted_10 = {
    key: 0,
    for: "imagenes-input",
    class: "add-image-slot"
};
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("svg", {
    class: "icon-add",
    xmlns: "http://www.w3.org/2000/svg",
    width: "32",
    height: "32",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
}, [
    /*#__PURE__*/ _createElementVNode("line", {
        x1: "12",
        y1: "5",
        x2: "12",
        y2: "19"
    }),
    /*#__PURE__*/ _createElementVNode("line", {
        x1: "5",
        y1: "12",
        x2: "19",
        y2: "12"
    })
], -1 /* HOISTED */));
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Añadir Imagen", -1 /* HOISTED */));
const _hoisted_13 = [
    _hoisted_11,
    _hoisted_12
];
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "32",
    height: "32",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
}, [
    /*#__PURE__*/ _createElementVNode("path", { d: "M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z" }),
    /*#__PURE__*/ _createElementVNode("circle", {
        cx: "12",
        cy: "13",
        r: "4"
    })
], -1 /* HOISTED */));
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Cámara", -1 /* HOISTED */));
const _hoisted_16 = [
    _hoisted_14,
    _hoisted_15
];
const _hoisted_17 = ["onClick"];
const _hoisted_18 = ["src"];
const _hoisted_19 = ["onClick"];
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "2.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
}, [
    /*#__PURE__*/ _createElementVNode("line", {
        x1: "18",
        y1: "6",
        x2: "6",
        y2: "18"
    }),
    /*#__PURE__*/ _createElementVNode("line", {
        x1: "6",
        y1: "6",
        x2: "18",
        y2: "18"
    })
], -1 /* HOISTED */));
const _hoisted_21 = [
    _hoisted_20
];
const _hoisted_22 = {
    key: 0,
    class: "portada-label"
};
const _hoisted_23 = {
    key: 2,
    class: "gallery-placeholder-empty"
};
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "48",
    height: "48",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
}, [
    /*#__PURE__*/ _createElementVNode("rect", {
        x: "3",
        y: "3",
        width: "18",
        height: "18",
        rx: "2",
        ry: "2"
    }),
    /*#__PURE__*/ _createElementVNode("circle", {
        cx: "8.5",
        cy: "8.5",
        r: "1.5"
    }),
    /*#__PURE__*/ _createElementVNode("polyline", { points: "21 15 16 10 5 21" })
], -1 /* HOISTED */));
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, "Sube tus imágenes o usa la cámara.", -1 /* HOISTED */));
const _hoisted_26 = { class: "form-section" };
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h3", { class: "form-section-title" }, "Información Principal y Precio", -1 /* HOISTED */));
const _hoisted_28 = { class: "row form-grid two-columns" };
const _hoisted_29 = { class: "col" };
const _hoisted_30 = { class: "form-group" };
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { for: "codigoUnico" }, "Código Único (SKU/Ref Interna):", -1 /* HOISTED */));
const _hoisted_32 = { class: "form-group" };
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { for: "repuestos" }, "Nombre del Repuesto:", -1 /* HOISTED */));
const _hoisted_34 = { class: "autocomplete" };
const _hoisted_35 = {
    key: 0,
    class: "autocomplete-list"
};
const _hoisted_36 = ["onClick", "innerHTML"];
const _hoisted_37 = {
    key: 0,
    class: "form-group atributos-dinamicos-container"
};
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { class: "form-label-subheading" }, "Características del Repuesto:", -1 /* HOISTED */));
const _hoisted_39 = { class: "atributos-grid" };
const _hoisted_40 = ["for"];
const _hoisted_41 = ["id", "onUpdate:modelValue"];
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", {
    value: "",
    disabled: ""
}, "Seleccionar", -1 /* HOISTED */));
const _hoisted_43 = ["value"];
const _hoisted_44 = ["id", "onUpdate:modelValue", "required"];
const _hoisted_45 = { class: "input-group" };
const _hoisted_46 = ["id", "onUpdate:modelValue", "onInput", "placeholder"];
const _hoisted_47 = {
    key: 0,
    class: "input-group-text"
};
const _hoisted_48 = {
    class: "toggle-wrapper",
    style: { "margin-top": "8px" }
};
const _hoisted_49 = { class: "switch" };
const _hoisted_50 = ["id", "onUpdate:modelValue"];
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "slider round" }, null, -1 /* HOISTED */));
const _hoisted_52 = { style: { "margin-left": "8px", "font-size": "0.9rem", "color": "#475569" } };
const _hoisted_53 = ["id", "onUpdate:modelValue"];
const _hoisted_54 = { style: { "display": "flex", "gap": "10px", "align-items": "center" } };
const _hoisted_55 = ["onUpdate:modelValue", "onInput", "placeholder"];
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { style: { "color": "#94a3b8" } }, "a", -1 /* HOISTED */));
const _hoisted_57 = ["onUpdate:modelValue", "onInput", "placeholder"];
const _hoisted_58 = {
    key: 0,
    style: { "color": "#64748b", "font-size": "0.85rem" }
};
const _hoisted_59 = { class: "col" };
const _hoisted_60 = { class: "form-group" };
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { for: "codigoBarrasReferencia" }, "Código de Barras (Referencia):", -1 /* HOISTED */));
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("small", { style: { "color": "#64748b", "font-size": "0.75rem" } }, "Limitado a 13 dígitos numéricos.", -1 /* HOISTED */));
const _hoisted_63 = { class: "form-group" };
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { for: "precioVenta" }, "Precio de Venta:", -1 /* HOISTED */));
const _hoisted_65 = { class: "input-group" };
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "input-group-text" }, "USD$", -1 /* HOISTED */));
const _hoisted_67 = { class: "form-group" };
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { for: "pesoLibras" }, "Peso en KG:", -1 /* HOISTED */));
const _hoisted_69 = { class: "input-group" };
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "input-group-text" }, "lbs", -1 /* HOISTED */));
const _hoisted_71 = { class: "form-section" };
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h3", { class: "form-section-title" }, "Información Adicional", -1 /* HOISTED */));
const _hoisted_73 = { class: "row form-grid one-column" };
const _hoisted_74 = { class: "col" };
const _hoisted_75 = { class: "form-group" };
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { for: "detalles" }, "Detalles y Observaciones:", -1 /* HOISTED */));
const _hoisted_77 = { class: "modal-actions" };
const _hoisted_78 = ["disabled"];
const _hoisted_79 = {
    key: 0,
    class: "spinner"
};
const _hoisted_80 = {
    key: 0,
    class: "camera-slide-in"
};
const _hoisted_81 = { class: "camera-content" };
const _hoisted_82 = {
    ref: "video",
    width: "320",
    height: "240",
    autoplay: "",
    playsinline: ""
};
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
}, [
    /*#__PURE__*/ _createElementVNode("path", { d: "M17 1l4 4-4 4" }),
    /*#__PURE__*/ _createElementVNode("path", { d: "M3 11V9a4 4 0 0 1 4-4h14" }),
    /*#__PURE__*/ _createElementVNode("path", { d: "M7 23l-4-4 4-4" }),
    /*#__PURE__*/ _createElementVNode("path", { d: "M21 13v2a4 4 0 0 1-4 4H3" })
], -1 /* HOISTED */));
const _hoisted_84 = [
    _hoisted_83
];
const _hoisted_85 = {
    key: 0,
    class: "camera-device-selector only-desktop"
};
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "cameraSelect",
    class: "selector-label"
}, "Seleccionar Cámara:", -1 /* HOISTED */));
const _hoisted_87 = ["value"];
const _hoisted_88 = { class: "modal-actions" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Header = _resolveComponent("Header");
    const _component_Sidebar = _resolveComponent("Sidebar");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_Header),
        _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_Sidebar),
            _createElementVNode("div", _hoisted_3, [
                _createCommentVNode(" Loading Overlay "),
                ($setup.isLoading)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                            _hoisted_6,
                            _createElementVNode("p", null, _toDisplayString($setup.isEditing ? 'Cargando datos del producto...' : 'Procesando...'), 1 /* TEXT */)
                        ])
                    ]))
                    : _createCommentVNode("v-if", true),
                _createElementVNode("form", {
                    onSubmit: _cache[11] || (_cache[11] = _withModifiers(
                    //@ts-ignore
                    (...args) => ($setup.saveProducto && $setup.saveProducto(...args)), ["prevent"]))
                }, [
                    _createCommentVNode(" Nueva Galería de Imágenes y Carga "),
                    _createElementVNode("div", _hoisted_7, [
                        _hoisted_8,
                        _createElementVNode("div", _hoisted_9, [
                            _createCommentVNode(" Slot para agregar nueva imagen desde archivo (disparador del input file) "),
                            ($setup.productoForm.imagenesDetalle.length < 5)
                                ? (_openBlock(), _createElementBlock("label", _hoisted_10, _hoisted_13))
                                : _createCommentVNode("v-if", true),
                            _createElementVNode("input", {
                                type: "file",
                                id: "imagenes-input",
                                onChange: _cache[0] || (_cache[0] =
                                    //@ts-ignore
                                    (...args) => ($setup.handleFileChange && $setup.handleFileChange(...args))),
                                multiple: "",
                                accept: "image/*",
                                capture: "environment",
                                style: { "display": "none" }
                            }, null, 32 /* NEED_HYDRATION */),
                            _createCommentVNode(" Slot para tomar foto con la cámara "),
                            ($setup.productoForm.imagenesDetalle.length < 5)
                                ? (_openBlock(), _createElementBlock("label", {
                                    key: 1,
                                    onClick: _cache[1] || (_cache[1] =
                                        //@ts-ignore
                                        (...args) => ($setup.openCamera && $setup.openCamera(...args))),
                                    class: "add-camera-slot"
                                }, _hoisted_16))
                                : _createCommentVNode("v-if", true),
                            _createCommentVNode(" Imágenes existentes "),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.productoForm.imagenesDetalle, (imagen, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                    key: imagen.id || index,
                                    class: _normalizeClass(["gallery-item", { 'selected': imagen.portada }]),
                                    onClick: ($event) => ($setup.setPortada(index))
                                }, [
                                    _createElementVNode("img", {
                                        src: imagen.imagenUrl,
                                        alt: "Imagen del producto",
                                        class: "gallery-image"
                                    }, null, 8 /* PROPS */, _hoisted_18),
                                    _createElementVNode("button", {
                                        type: "button",
                                        onClick: _withModifiers(($event) => ($setup.removeImage(index)), ["stop"]),
                                        class: "btn-remove-image",
                                        title: "Eliminar imagen"
                                    }, _hoisted_21, 8 /* PROPS */, _hoisted_19),
                                    (imagen.portada)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_22, "Portada"))
                                        : _createCommentVNode("v-if", true)
                                ], 10 /* CLASS, PROPS */, _hoisted_17));
                            }), 128 /* KEYED_FRAGMENT */)),
                            _createCommentVNode(" Placeholder si no hay imágenes y se pueden agregar más "),
                            ($setup.productoForm.imagenesDetalle.length === 0 && $setup.productoForm.imagenesDetalle.length < 5)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                    _hoisted_24,
                                    _hoisted_25,
                                    _createCommentVNode(" Texto del placeholder actualizado ")
                                ]))
                                : _createCommentVNode("v-if", true)
                        ]),
                        _createCommentVNode(" El div con el botón de cámara separado ha sido eliminado ")
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                        _hoisted_27,
                        _createElementVNode("div", _hoisted_28, [
                            _createCommentVNode(" Grid de dos columnas "),
                            _createCommentVNode(" COLUMNA IZQUIERDA "),
                            _createElementVNode("div", _hoisted_29, [
                                _createElementVNode("div", _hoisted_30, [
                                    _hoisted_31,
                                    _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => (($setup.productoForm.codigoUnico) = $event)),
                                        id: "codigoUnico",
                                        placeholder: "Ej: SKU-12345",
                                        required: ""
                                    }, null, 512 /* NEED_PATCH */), [
                                        [_vModelText, $setup.productoForm.codigoUnico]
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_32, [
                                    _hoisted_33,
                                    _createElementVNode("div", _hoisted_34, [
                                        _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => (($setup.searchRepuestos) = $event)),
                                            onInput: _cache[4] || (_cache[4] =
                                                //@ts-ignore
                                                (...args) => ($setup.searchRepuesto && $setup.searchRepuesto(...args))),
                                            placeholder: "Buscar y seleccionar repuesto..."
                                        }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                                            [_vModelText, $setup.searchRepuestos]
                                        ]),
                                        ($setup.filteredRepuestos.length > 0 && $setup.searchRepuestos.length >= 3)
                                            ? (_openBlock(), _createElementBlock("ul", _hoisted_35, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filteredRepuestos, (repuesto) => {
                                                    return (_openBlock(), _createElementBlock("li", {
                                                        key: repuesto.repuestoID,
                                                        onClick: ($event) => ($setup.selectRepuesto(repuesto)),
                                                        innerHTML: repuesto.highlightedNombre
                                                    }, null, 8 /* PROPS */, _hoisted_36));
                                                }), 128 /* KEYED_FRAGMENT */))
                                            ]))
                                            : _createCommentVNode("v-if", true)
                                    ])
                                ]),
                                _createCommentVNode(" Atributos del Repuesto Seleccionado "),
                                ($setup.productoForm.atributosDesplegables.length > 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                        _hoisted_38,
                                        _createElementVNode("div", _hoisted_39, [
                                            _createCommentVNode(" Contenedor para los atributos "),
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.productoForm.atributosDesplegables, (atributo, index) => {
                                                return (_openBlock(), _createElementBlock("div", {
                                                    key: atributo.nombreAtributoID || index,
                                                    class: "form-group atributo-item"
                                                }, [
                                                    _createElementVNode("label", {
                                                        for: 'atributo-' + (atributo.nombreAtributoID || index)
                                                    }, _toDisplayString(atributo.nombreAtributo && atributo.nombreAtributo.nombreAtributo ?
                                                        atributo.nombreAtributo.nombreAtributo : 'Atributo') + ": ", 9 /* TEXT, PROPS */, _hoisted_40),
                                                    _createCommentVNode(" DESPLEGABLE TRADICIONAL "),
                                                    (!atributo.nombreAtributo?.tipoAtributo || atributo.nombreAtributo?.tipoAtributo === 'desplegable')
                                                        ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                                            key: 0,
                                                            id: 'atributo-' + (atributo.nombreAtributoID || index),
                                                            "onUpdate:modelValue": ($event) => ((atributo.selectedValue) = $event),
                                                            class: "form-control",
                                                            required: ""
                                                        }, [
                                                            _hoisted_42,
                                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(atributo.nombreAtributo?.valoresOrdenados, (valor) => {
                                                                return (_openBlock(), _createElementBlock("option", {
                                                                    key: valor.valorID,
                                                                    value: valor.valorID
                                                                }, _toDisplayString(valor.valor), 9 /* TEXT, PROPS */, _hoisted_43));
                                                            }), 128 /* KEYED_FRAGMENT */))
                                                        ], 8 /* PROPS */, _hoisted_41)), [
                                                            [_vModelSelect, atributo.selectedValue]
                                                        ])
                                                        : (atributo.nombreAtributo?.tipoAtributo === 'texto_libre' || atributo.nombreAtributo?.nombreAtributo === 'Ref')
                                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                                _createCommentVNode(" TEXTO LIBRE o REF "),
                                                                _withDirectives(_createElementVNode("input", {
                                                                    type: "text",
                                                                    id: 'atributo-' + (atributo.nombreAtributoID || index),
                                                                    "onUpdate:modelValue": ($event) => ((atributo.valorLibre) = $event),
                                                                    placeholder: "Escriba aquí...",
                                                                    class: "form-control",
                                                                    required: atributo.nombreAtributo?.nombreAtributo === 'Ref'
                                                                }, null, 8 /* PROPS */, _hoisted_44), [
                                                                    [_vModelText, atributo.valorLibre]
                                                                ])
                                                            ], 64 /* STABLE_FRAGMENT */))
                                                            : (atributo.nombreAtributo?.tipoAtributo === 'numerico')
                                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                                                    _createCommentVNode(" NUMÉRICO "),
                                                                    _createElementVNode("div", _hoisted_45, [
                                                                        _withDirectives(_createElementVNode("input", {
                                                                            type: "text",
                                                                            id: 'atributo-' + (atributo.nombreAtributoID || index),
                                                                            "onUpdate:modelValue": ($event) => ((atributo.valorLibreFormatted) = $event),
                                                                            onInput: ($event) => ($setup.onAttributeInput(atributo, 'valorLibre')),
                                                                            placeholder: $setup.getPlaceholder(atributo),
                                                                            class: "form-control"
                                                                        }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_46), [
                                                                            [_vModelText, atributo.valorLibreFormatted]
                                                                        ]),
                                                                        (atributo.nombreAtributo?.unidad)
                                                                            ? (_openBlock(), _createElementBlock("span", _hoisted_47, _toDisplayString(atributo.nombreAtributo.unidad.simbolo), 1 /* TEXT */))
                                                                            : _createCommentVNode("v-if", true)
                                                                    ])
                                                                ], 64 /* STABLE_FRAGMENT */))
                                                                : (atributo.nombreAtributo?.tipoAtributo === 'booleano')
                                                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                                                        _createCommentVNode(" BOOLEANO "),
                                                                        _createElementVNode("div", _hoisted_48, [
                                                                            _createElementVNode("label", _hoisted_49, [
                                                                                _createCommentVNode(" Guardaremos 'true' o 'false' como string en valorLibre "),
                                                                                _withDirectives(_createElementVNode("input", {
                                                                                    type: "checkbox",
                                                                                    id: 'atributo-' + (atributo.nombreAtributoID || index),
                                                                                    "onUpdate:modelValue": ($event) => ((atributo.valorLibre) = $event),
                                                                                    "true-value": "true",
                                                                                    "false-value": "false"
                                                                                }, null, 8 /* PROPS */, _hoisted_50), [
                                                                                    [_vModelCheckbox, atributo.valorLibre]
                                                                                ]),
                                                                                _hoisted_51
                                                                            ]),
                                                                            _createElementVNode("span", _hoisted_52, _toDisplayString(atributo.valorLibre === 'true' ? 'Sí' : 'No'), 1 /* TEXT */)
                                                                        ])
                                                                    ], 64 /* STABLE_FRAGMENT */))
                                                                    : (atributo.nombreAtributo?.tipoAtributo === 'fecha')
                                                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                                                            _createCommentVNode(" FECHA "),
                                                                            _withDirectives(_createElementVNode("input", {
                                                                                type: "date",
                                                                                id: 'atributo-' + (atributo.nombreAtributoID || index),
                                                                                "onUpdate:modelValue": ($event) => ((atributo.valorLibre) = $event),
                                                                                class: "form-control"
                                                                            }, null, 8 /* PROPS */, _hoisted_53), [
                                                                                [_vModelText, atributo.valorLibre]
                                                                            ])
                                                                        ], 64 /* STABLE_FRAGMENT */))
                                                                        : (atributo.nombreAtributo?.tipoAtributo === 'rango')
                                                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                                                                                _createCommentVNode(" RANGO "),
                                                                                _createElementVNode("div", _hoisted_54, [
                                                                                    _withDirectives(_createElementVNode("input", {
                                                                                        type: "text",
                                                                                        "onUpdate:modelValue": ($event) => ((atributo.valorMinFormatted) = $event),
                                                                                        onInput: ($event) => ($setup.onAttributeInput(atributo, 'valorMin')),
                                                                                        placeholder: $setup.getPlaceholder(atributo),
                                                                                        class: "form-control"
                                                                                    }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_55), [
                                                                                        [_vModelText, atributo.valorMinFormatted]
                                                                                    ]),
                                                                                    _hoisted_56,
                                                                                    _withDirectives(_createElementVNode("input", {
                                                                                        type: "text",
                                                                                        "onUpdate:modelValue": ($event) => ((atributo.valorMaxFormatted) = $event),
                                                                                        onInput: ($event) => ($setup.onAttributeInput(atributo, 'valorMax')),
                                                                                        placeholder: $setup.getPlaceholder(atributo),
                                                                                        class: "form-control"
                                                                                    }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_57), [
                                                                                        [_vModelText, atributo.valorMaxFormatted]
                                                                                    ]),
                                                                                    (atributo.nombreAtributo?.unidad)
                                                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_58, _toDisplayString(atributo.nombreAtributo.unidad.simbolo), 1 /* TEXT */))
                                                                                        : _createCommentVNode("v-if", true)
                                                                                ])
                                                                            ], 64 /* STABLE_FRAGMENT */))
                                                                            : _createCommentVNode("v-if", true)
                                                ]));
                                            }), 128 /* KEYED_FRAGMENT */))
                                        ])
                                    ]))
                                    : _createCommentVNode("v-if", true)
                            ]),
                            _createCommentVNode(" COLUMNA DERECHA "),
                            _createElementVNode("div", _hoisted_59, [
                                _createElementVNode("div", _hoisted_60, [
                                    _hoisted_61,
                                    _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => (($setup.productoForm.codigoBarrasReferencia) = $event)),
                                        id: "codigoBarrasReferencia",
                                        placeholder: "Máx. 13 dígitos",
                                        maxlength: "13",
                                        onInput: _cache[6] || (_cache[6] = ($event) => ($setup.productoForm.codigoBarrasReferencia = $setup.productoForm.codigoBarrasReferencia.replace(/\D/g, '')))
                                    }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                                        [_vModelText, $setup.productoForm.codigoBarrasReferencia]
                                    ]),
                                    _hoisted_62
                                ]),
                                _createElementVNode("div", _hoisted_63, [
                                    _hoisted_64,
                                    _createElementVNode("div", _hoisted_65, [
                                        _hoisted_66,
                                        _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => (($setup.precioVentaFormatted) = $event)),
                                            onInput: _cache[8] || (_cache[8] =
                                                //@ts-ignore
                                                (...args) => ($setup.onPrecioVentaInput && $setup.onPrecioVentaInput(...args))),
                                            id: "precioVenta",
                                            required: ""
                                        }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                                            [_vModelText, $setup.precioVentaFormatted]
                                        ])
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_67, [
                                    _hoisted_68,
                                    _createElementVNode("div", _hoisted_69, [
                                        _withDirectives(_createElementVNode("input", {
                                            type: "number",
                                            step: "0.01",
                                            min: "0",
                                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => (($setup.productoForm.pesoKG) = $event)),
                                            id: "pesoLibras",
                                            placeholder: "0.00",
                                            required: ""
                                        }, null, 512 /* NEED_PATCH */), [
                                            [
                                                _vModelText,
                                                $setup.productoForm.pesoKG,
                                                void 0,
                                                { number: true }
                                            ]
                                        ]),
                                        _hoisted_70
                                    ])
                                ])
                            ])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_71, [
                        _hoisted_72,
                        _createElementVNode("div", _hoisted_73, [
                            _createCommentVNode(" Grid de una columna para detalles "),
                            _createElementVNode("div", _hoisted_74, [
                                _createElementVNode("div", _hoisted_75, [
                                    _hoisted_76,
                                    _withDirectives(_createElementVNode("textarea", {
                                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => (($setup.productoForm.detalles) = $event)),
                                        id: "detalles",
                                        rows: "2"
                                    }, null, 512 /* NEED_PATCH */), [
                                        [_vModelText, $setup.productoForm.detalles]
                                    ])
                                ])
                            ])
                        ])
                    ]),
                    _createCommentVNode(" Acciones del formulario "),
                    _createElementVNode("div", _hoisted_77, [
                        _createElementVNode("button", {
                            type: "submit",
                            class: "btn-save",
                            disabled: $setup.isLoading
                        }, [
                            ($setup.isLoading)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_79))
                                : _createCommentVNode("v-if", true),
                            _createTextVNode(" " + _toDisplayString($setup.isLoading ? ($setup.isEditing ? 'Actualizando...' : 'Guardando...') : ($setup.isEditing ? 'Actualizar Producto' : 'Guardar Producto')), 1 /* TEXT */)
                        ], 8 /* PROPS */, _hoisted_78)
                    ])
                ], 32 /* NEED_HYDRATION */)
            ]),
            _createCommentVNode(" Slide-in modal para captura de cámara "),
            _createVNode(_Transition, { name: "slide" }, {
                default: _withCtx(() => [
                    ($setup.isCameraOpen)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                            _createElementVNode("div", _hoisted_81, [
                                _createElementVNode("video", _hoisted_82, null, 512 /* NEED_PATCH */),
                                _createElementVNode("button", {
                                    type: "button",
                                    onClick: _cache[12] || (_cache[12] =
                                        //@ts-ignore
                                        (...args) => ($setup.switchCamera && $setup.switchCamera(...args))),
                                    class: "btn-flip-camera-mini",
                                    title: "Cambiar cámara"
                                }, _hoisted_84),
                                _createElementVNode("label", null, [
                                    _withDirectives(_createElementVNode("input", {
                                        type: "checkbox",
                                        style: { "margin-top": "10px" },
                                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => (($setup.removeGreenScreen) = $event))
                                    }, null, 512 /* NEED_PATCH */), [
                                        [_vModelCheckbox, $setup.removeGreenScreen]
                                    ]),
                                    _createTextVNode(" Eliminar fondo automáticamente ")
                                ]),
                                _createCommentVNode(" Selector de cámara (Solo Escritorio) "),
                                ($setup.videoDevices.length > 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_85, [
                                        _hoisted_86,
                                        _withDirectives(_createElementVNode("select", {
                                            id: "cameraSelect",
                                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event) => (($setup.selectedDeviceId) = $event)),
                                            onChange: _cache[15] || (_cache[15] =
                                                //@ts-ignore
                                                (...args) => ($setup.onCameraDeviceChange && $setup.onCameraDeviceChange(...args))),
                                            class: "selector-input"
                                        }, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.videoDevices, (device) => {
                                                return (_openBlock(), _createElementBlock("option", {
                                                    key: device.deviceId,
                                                    value: device.deviceId
                                                }, _toDisplayString(device.label || `Cámara ${$setup.videoDevices.indexOf(device) + 1}`), 9 /* TEXT, PROPS */, _hoisted_87));
                                            }), 128 /* KEYED_FRAGMENT */))
                                        ], 544 /* NEED_HYDRATION, NEED_PATCH */), [
                                            [_vModelSelect, $setup.selectedDeviceId]
                                        ])
                                    ]))
                                    : _createCommentVNode("v-if", true),
                                _createElementVNode("div", _hoisted_88, [
                                    _createElementVNode("button", {
                                        onClick: _cache[16] || (_cache[16] =
                                            //@ts-ignore
                                            (...args) => ($setup.captureImage && $setup.captureImage(...args))),
                                        class: "btn-save"
                                    }, " Capturar Imagen "),
                                    _createElementVNode("button", {
                                        onClick: _cache[17] || (_cache[17] =
                                            //@ts-ignore
                                            (...args) => ($setup.closeCamera && $setup.closeCamera(...args))),
                                        class: "btn-cancel"
                                    }, " Cerrar Cámara ")
                                ])
                            ])
                        ]))
                        : _createCommentVNode("v-if", true)
                ]),
                _: 1 /* STABLE */
            })
        ])
    ]));
}
